// DS: i6.22
import React from 'react';
import IconWrap from '../../IconWrap';
const AddEmoticon = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 2c5.5228 0 10 4.4772 10 10s-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2zm0 2c-4.4183 0-8 3.5817-8 8s3.5817 8 8 8 8-3.5817 8-8-3.5817-8-8-8zm4 10c0 2.2091-1.7909 4-4 4-2.1422 0-3.891-1.684-3.9951-3.8004L8 14h8zM9.5 9c.8284 0 1.5.6716 1.5 1.5S10.3284 12 9.5 12 8 11.3284 8 10.5 8.6716 9 9.5 9zm5 0c.8284 0 1.5.6716 1.5 1.5s-.6716 1.5-1.5 1.5-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5z",
        fillRule: "evenodd"
    })));
};
AddEmoticon.displayName = 'AddEmoticon';
export default AddEmoticon;
